module.exports = __webpack_public_path__ + "media/images/front/special-0e07c5e369187fa0d3a92ed1d2f5949f.png";